import { render, staticRenderFns } from "./InvoiceForm.vue?vue&type=template&id=b17fdfa0&scoped=true&"
import script from "./InvoiceForm.vue?vue&type=script&lang=ts&"
export * from "./InvoiceForm.vue?vue&type=script&lang=ts&"
import style0 from "./InvoiceForm.vue?vue&type=style&index=0&id=b17fdfa0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b17fdfa0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCard,VCardText,VCol,VForm,VRow,VTextField})
